import React from 'react';
import { ShieldCheckIcon, SparklesIcon } from 'lucide-react';
import { CtaButton } from './CtaButton';
import { Countdown } from './Countdown';
import { ScarcitySpots } from './ScarcitySpots';
import { IMAGES } from '../data/content';
export function Hero() {
  return <header className="relative overflow-hidden bg-navy" data-id="element-144" data-mp="4lqjixa15f41">
      <div className="pointer-events-none absolute -top-24 left-1/2 h-64 w-[130%] -translate-x-1/2 rounded-full bg-navy2/60 blur-3xl" aria-hidden="true" data-id="element-145" data-mp="4n9z0lnv3m4r" />

      <div className="relative mx-auto w-full max-w-5xl px-4 pb-10 pt-8 sm:px-6 sm:pt-12" data-id="element-146" data-mp="xbfk59itvd54">
        <div className="flex flex-col items-center gap-3" data-id="element-147" data-mp="sai3509k0p57">
          <div className="flex items-center gap-2 rounded-full border border-white/15 bg-white/5 px-3.5 py-1.5" data-id="element-148" data-mp="sd4bv386lap0">
            <span className="text-base" aria-hidden="true" data-id="element-149" data-mp="3d1a83izra9cr">
              🦷
            </span>
            <span className="text-[10.5px] font-extrabold uppercase tracking-[0.16em] text-white sm:text-xs" data-id="element-150" data-mp="382fhvvzgliim">
              Aligner Treatment Blueprint™
            </span>
          </div>
          <p className="text-center text-[10.5px] font-bold uppercase tracking-[0.2em] text-sky" data-id="element-151" data-mp="3j6oe7qokeyt9">
            The visual system for planning aligner cases
          </p>
        </div>

        <h1 className="mt-6 text-center text-[30px] font-black leading-[1.08] tracking-tight text-white sm:text-5xl lg:text-[56px]" data-id="element-152" data-mp="39cflb1vmh3uk">
          Organize any aligner case in
          <span className="mt-1 block text-sky" data-id="element-153" data-mp="30h9d5w8vq9ov">less than 15 minutes</span>
        </h1>

        <p className="mx-auto mt-5 max-w-2xl text-center text-[15px] leading-relaxed text-white/80 sm:text-lg" data-id="element-154" data-mp="359t03jtgih6c">
          A step-by-step clinical organization system designed to help you
          structure case information, organize treatment planning, and know what
          to review before moving forward. Includes{' '}
          <strong className="font-bold text-white" data-id="element-155" data-mp="2hjypl8wm14p9">6 premium volumes</strong>,{' '}
          <strong className="font-bold text-white" data-id="element-156" data-mp="2ljgz78izdtcs">5 professional bonuses</strong>{' '}
          and{' '}
          <strong className="font-bold text-white" data-id="element-157" data-mp="s3mc1z88nsws">30+ planning tools</strong>.
        </p>

        <div className="mt-7" data-id="element-158" data-mp="najgjljwi9dy">
          <img src={IMAGES.mainMockup} alt="The complete Aligner Treatment Blueprint collection: six premium volumes, planning maps, checklists, trackers and quick-reference cards." className="mx-auto w-full max-w-[560px]" loading="eager" data-id="element-159" data-mp="n98djnya55nw" />
        </div>

        <div className="mx-auto mt-6 max-w-md" data-id="element-160" data-mp="161t2wverssmy">
          <CtaButton id="hero-cta" label="Get the Aligner Treatment Blueprint™" subLabel="Instant digital access · One-time payment of $27 · Lifetime access · 7-day guarantee" data-id="element-161" data-mp="16346au4azydj" />
        </div>

        <div className="mx-auto mt-8 max-w-md" data-id="element-162" data-mp="x37falufynfb">
          <Countdown tone="dark" footnote="Limited launch pricing available" data-id="element-163" data-mp="3lt740mm25js5" />
        </div>

        <div className="mx-auto mt-6 max-w-md" data-id="element-164" data-mp="3hr3s5wvh8d6c">
          <ScarcitySpots tone="dark" data-id="element-165" data-mp="3htg864hocdgr" />
        </div>

        <ul className="mx-auto mt-6 flex max-w-md flex-col gap-2 text-[12.5px] font-semibold text-white/75 sm:flex-row sm:justify-center sm:gap-5" data-id="element-166" data-mp="1xa43telg8kjm">
          <li className="flex items-center justify-center gap-2" data-id="element-167" data-mp="218tq5wogtcfe">
            <SparklesIcon className="h-4 w-4 text-sky" aria-hidden="true" data-id="element-168" data-mp="2697mwikm8zy4" />
            Instant digital access
          </li>
          <li className="flex items-center justify-center gap-2" data-id="element-169" data-mp="2b2smug5rs3zy">
            <ShieldCheckIcon className="h-4 w-4 text-sky" aria-hidden="true" data-id="element-170" data-mp="2fyr8vx3ml9x7" />
            Automatic currency conversion
          </li>
        </ul>
      </div>
    </header>;
}